import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPredictors,
  selectIsLoading,
  selectLastPredictor,
  selectPredictorsCount,
} from "redux-toolkit/predictors/selectors";
import {
  getPredictorsAsync,
  getNextPredictorsAsync,
} from "redux-toolkit/predictors/actions";

const usePredictors = (filters = {}) => {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const predictors = useSelector(selectPredictors);
  const isLoading = useSelector(selectIsLoading);
  const last = useSelector(selectLastPredictor);
  const count = useSelector(selectPredictorsCount);

  useEffect(() => {
    dispatch(getPredictorsAsync(filters));
  }, [dispatch, filters]);

  const getNextPage = () => {
    if (last && count > predictors.length) {
      dispatch(getNextPredictorsAsync({ last, filters }));
      setPage(page + 1);
    }
  };

  return {
    predictors,
    isLoading,
    hasMoreItems: count > predictors.length,
    page,
    count,
    setPage,
    getNextPage,
  };
};

export default usePredictors;
